import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getOrderUspsLabelApi } from './getOrderUspsLabel.api'
import getOrderUspsLabelInitialState from './getOrderUspsLabel.initialState'
import { GetOrderUspsLabelErrorResponse, GetOrderUspsLabelRequestPayload } from './getOrderUspsLabel.types'

export const getOrderUspsLabel = createAsyncThunk(
  urls.logisticsPartner.getOrderUspsLabel,
  async (payload: GetOrderUspsLabelRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload || {}

    try {
      const response = await getOrderUspsLabelApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      const apiError = error as ApiErrorResponse

      errorHandler.handleApiError(apiError)

      return rejectWithValue(apiError as GetOrderUspsLabelErrorResponse)
    }
  }
)

const getOrderUspsLabelSlice = createSlice({
  name: urls.logisticsPartner.getOrderUspsLabel,
  initialState: getOrderUspsLabelInitialState,
  reducers: {
    resetGetOrderUspsLabel: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrderUspsLabel.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getOrderUspsLabel.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getOrderUspsLabel.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetOrderUspsLabelErrorResponse
        state.success = null
      })
  }
})

export const { actions: getOrderUspsLabelActions, reducer: getOrderUspsLabelReducer } = getOrderUspsLabelSlice
export const { resetGetOrderUspsLabel } = getOrderUspsLabelActions
export default getOrderUspsLabelSlice.reducer
